import { Auth0Provider } from '@auth0/auth0-react';
import { createTheme, type MantineColorsTuple, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import AnalyticsConsent from './components/analytics/AnalyticsConsent';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';
import '@fontsource-variable/sora';
import '@fontsource-variable/source-sans-3';

const queryClient = new QueryClient();

function App() {
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  console.log('prefersDark', prefersDark);
  const myColor: MantineColorsTuple = [
    '#e1f8ff',
    '#cbedff',
    '#9ad7ff',
    '#64c1ff',
    '#3aaefe',
    '#20a2fe',
    '#099cff',
    '#0088e4',
    '#0079cd',
    '#0068b6',
  ];
  const theme = createTheme({
    fontFamily: 'Roboto, Open Sans, sans-serif',
    colors: {
      myColor,
    },
    primaryColor: 'myColor',
  });

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={(appState) => {
        const returnTo = typeof appState?.returnTo === 'string' ? appState.returnTo : '/';
        const safeReturnTo = returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/';
        window.history.replaceState({}, document.title, safeReturnTo);
      }}
    >
      <QueryClientProvider client={queryClient}>
        <MantineProvider theme={theme}>
          <Notifications />
          <Router>
            <AppLayout />
            <AnalyticsConsent />
          </Router>
        </MantineProvider>
      </QueryClientProvider>
    </Auth0Provider>
  );
}

export default App;
